'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var billingTermByMerchIdSelector = exports.billingTermByMerchIdSelector = function billingTermByMerchIdSelector(state, merchandiseId) {
  return state.billingTerms && state.billingTerms[merchandiseId];
};


//////////////////
// WEBPACK FOOTER
// ./js/selectors/BillingTermSelectors.js
// module id = 764
// module chunks = 3 4